<div class="container my-5">
    <div class="row justify-content-center">
        <div class="col-xl-7 col-lg-9">
            <div class="bg-card-new card-radius-x2 flex-grow-1">
                <div class="title">
                    {{"request_successful"|translate}}
                </div>
                <div class="apply-vendor">
                    <div class="illustration">
                        <img src="assets/images/business_illustration.png">
                    </div>
                    <p class="form-success-text">{{"apply_vendor_form_success"|translate}}</p>
                </div>
            </div>
        </div>
    </div>
</div>
